import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox, Form } from "antd";
import styled from "styled-components";

export const TableFormItem = styled(Form.Item)`
  margin-bottom: 0;
`;

export const CheckboxGroup = styled(Checkbox.Group)`
  display: grid;
`;

export const ProjectTemplateErrorModalTextContainer = styled.div`
  margin-top: 10px;
  color: #db011c;
`;

export const ProjectTemplateErrorModalAlertIcon = styled(FontAwesomeIcon)`
  font-size: 60px;
  color: #db011c;
`;

export const CenteredIconContainer = styled.div`
  text-align: center;
  font-weight: bold;
`;
